<script>

    export default {

        name: 'PageHero',

        data() {
            return {
                isActiveRow1: false,
                isActiveRow2: false,
                isActiveRow3: false,
            };
        },

        mounted() {
            setTimeout(() => this.isActiveRow1 = true, 600);
            setTimeout(() => this.isActiveRow2 = true, 1200);
            setTimeout(() => this.isActiveRow3 = true, 1800);
        },

    };
</script>
